import { makeStyles } from "@material-ui/core";
import { filter, get, map, size } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import Gallery from "react-photo-gallery";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, matchPath, useLocation } from "react-router-dom";
import { showError, showSuccess } from "../v2_actions/error";
import { galleryList } from "../v2_actions/gallery";
import { confirmModal } from "../v2_actions/ui";
import { PageLayout } from "./layout/PageLayout";
import { Map } from "./layout/Map";
import { PhotoArtGalleries } from "./PhotoArtGalleries";
import AllGalleries from "./layout/AllGalleries";
import { setSelectedGallery, setEditingGallery } from "../actions/gallery";

const ROW_HEIGHT = "200px";

const useStyles = makeStyles({
  photo_art_galleries_container: {
    display: "flex",
    height: ROW_HEIGHT,
    background: "#ffffff",
    "border-color": "#000000",
    "border-width": "1px",
    "border-style": "solid",
    width: "calc(100%)",
    height: "100%",
  },
  opaque: {
    opacity: "0.30 !important",
  },
  photo_art_gallery_container: {
    margin: "10px",
    position: "relative",
    height: ROW_HEIGHT,
    backgroundColor: "lightgray",
  },
  photograph: {
    height: ROW_HEIGHT,
  },
  gallerySpecificAction: {
    display: "flex",
    alignItems: "center",
  },
});

export const GalleriesView = () => {
  const galleries = useSelector(() => galleryList.getVisibleObjects());

  const canEditGallery = useSelector((state) => state.gallery.editGalleryAble);

  const [showMap, setShowMap] = useState(false);

  const photo_art_galleries = filter(
    galleries,
    (gallery) => gallery.gallery_type === "photo_art",
  );
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const isCreateNew = matchPath(history.location.pathname, {
    path: "/photographer/map/new",
    exact: true,
    strict: false,
  });

  useEffect(() => {
    if (isCreateNew) {
      dispatch(setEditingGallery({}));
    } else {
      dispatch(setEditingGallery(null));
    }
  }, [location]);

  const onEditPhotoArtGallery = (photograph) => {
    const photo_art_gallery_id = get(photograph, "gallery");
    history.push(`/photographer/gallery/${photo_art_gallery_id}`);
  };

  const onDeletePhotoArtGallery = (photograph) => {
    const gallery_id = get(photograph, "gallery");
    const gallery = galleryList.getObject(gallery_id);

    const onDeleted = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Removed", "Removed image from Photo Art gallery");
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, gallery, {
        available_to_purchase: false,
      });
      dispatch(galleryList.saveObject(values)).then(onDeleted);
    };

    dispatch(
      confirmModal({
        text: "Are you sure you want to make this photo unavailable to purchase?",
        onConfirmed: onConfirmed,
        can_cancel: true,
      }),
    );
  };

  const imageRenderer = useCallback(function ({ photo }) {
    return (
      <>
        <PhotoArtGalleries
          onDeletePhotoArtGallery={onDeletePhotoArtGallery}
          onEditPhotoArtGallery={onEditPhotoArtGallery}
          photo={photo}
        />
      </>
    );
  }, []);


  return (
    <PageLayout>
      <div
        className={`${classes.photo_art_galleries_container} ${
          isCreateNew || canEditGallery ? classes.opaque : ""
        }`}
        disabled={isCreateNew}
      >
        <AllGalleries />
      </div>
    </PageLayout>
  );
};
